import {SecureService} from "@/services/superclasses/secure-service";
import {Category} from "@/interfaces/category";

const api = window.contextPath + '/rest/categories';

export class CategorySecureService extends SecureService {

    public loadById = async (id: number): Promise<Category[]> => {
        return this.data(await this.get<Category[]>(api + "/" + id))
    };

    public search = async (args: {
        q?: string,
        type: Array<number>,
        industry?: Array<number>,
        business?: Array<number>,
        first?: number,
        max?: number
    }): Promise<Category[]> => {
        return this.data(await this.get<Category[]>(api,
            {
                params: args
            }))
    }

    public loadByParent = async (args: {
        parent?: number,
        type: Array<number>,
        industry?: Array<number>,
        business?: Array<number>
    }): Promise<Category[]> => {
        return this.data(await this.get<Category[]>(api + "/by-parent",
            {
                params: args
            }))
    }

    public loadPath = async (id: number): Promise<Category[]> => {
        return this.data(await this.get<Category[]>(api + "/path",
            {
                params: {
                    id
                }
            }))
    }

    public loadTree = async (args: {
        type: Array<number>,
        industry?: Array<number>,
        business?: Array<number>
    }): Promise<Category[]> => {
        return this.data(await this.get<Category[]>(api + "/tree",
            {
                params: args
            }))
    }

    public loadMostUsedInPostsByMember = async (args: {
        type: Array<number>,
        industry?: Array<number>,
        business?: Array<number>,
        first?: number,
        max?: number
    }): Promise<Category[]> => {
        return this.data(await this.get<Category[]>(api + "/most-used-in-posts-by-member",
            {
                params: args
            }))
    }

    public loadLastUsedInPostsByMember = async (args: {
        type: Array<number>,
        industry?: Array<number>,
        business?: Array<number>
    }): Promise<Category> => {
        return this.data(await this.get<Category>(api + "/last-used-in-posts-by-member",
            {
                params: args
            }))
    }
}

export const categorySecureService = new CategorySecureService()